import OrdersContainer from './OrdersContainer.jsx';
import OrderDetailContainer from './OrderDetailContainer.jsx';
import ClosedOrdersContainer from './ClosedOrdersContainer.jsx';
import CancelledOrdersContainer from './CancelledOrdersContainer.jsx';

export {OrdersContainer, OrderDetailContainer, ClosedOrdersContainer, CancelledOrdersContainer}



// WEBPACK FOOTER //
// ./pages/orders/index.js